var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconModuleProtect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5,0.5 H9.5 Q11,0.5 11,2 V6 A5,5.5 0 0 1 1,6 V2 Q1,0.5 2.5,0.5 Z M2.5,0.82 Q1.32,0.82 1.32,2 V6 A4.68,5.18 0 0 0 10.68,6 V2 Q10.68,0.82 9.5,0.82 H2.5 Z M3.5,1.8 H8.5 Q9.7,1.8 9.7,3 V6 A3.7,4.2 0 0 1 2.3,6 V3 Q2.3,1.8 3.5,1.8 Z M3.5,2.12 Q2.62,2.12 2.62,3 V6 A3.38,3.88 0 0 0 9.38,6 V3 Q9.38,2.12 8.5,2.12 H3.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModuleProtect);
export default __webpack_public_path__ + "static/media/icon_module_protect.5bf6bfff48bef1cf68adec723e7ed425.svg";
export { ForwardRef as ReactComponent };